import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import api from "@/api/shipin2/index.js";
import { onMounted, ref, computed } from "vue";
import { ensureCategory } from '../utils/dataCache.js';
import { useRouter, useRoute } from "vue-router";
import { store } from '../utils/store.js';
export default {
  __name: 'CommonHeader',
  props: {
    categoryNavShow: {
      default: true //nav是否显示
    },

    noticeBarShow: {
      default: true //公告是否显示
    }
  },

  emits: ['query'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const route = useRoute();
    const oldScrollTop = ref(0);
    const isHide = ref(false);
    const scrollTop = ref(0);
    const showFixNav = ref(false);
    const cateRed = ref();
    const scrolling = event => {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      // 设置上边界 未超过显示
      if (scrollTop.value < 100) {
        showFixNav.value = false;
        return isHide.value = false;
      }
      if (scrollTop.value > 100) {
        showFixNav.value = true;
      }

      // // 返回页面的时候设置显示
      // if (scrollTop.value === 0) {
      //   return scrollTop.value = false
      // }

      // 设置下边界 滑动到下边界后隐藏顶部 
      if (scrollTop.value + document.documentElement.clientHeight >= document.body.scrollHeight - 100) {
        return isHide.value = true;
      }

      // 滚动条滚动的距离
      let scrollStep = scrollTop.value - oldScrollTop.value;
      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop.value;
      if (scrollTop.value + document.documentElement.clientHeight === document.body.scrollHeight) {
        return isHide.value = false;
      }
      if (scrollStep < 0) {
        isHide.value = false;
      } else {
        isHide.value = true;
      }
    };
    const categoryList = computed(() => store.categoryList);
    window.addEventListener("scroll", scrolling);
    const queryList = item => {
      emits('query', item);
    };

    // 查询分类列表（带缓存与去重）
    const queryClassificationList = async () => {
      await ensureCategory();
      // res.data.splice(1, 0, {
      //   "tid": 0,
      //   "id": 0,
      //   "type": "hot",
      //   "url": "",
      //   "name": "热门",
      //   "title": "热门",
      //   "only_topic": "0"
      // })
    };

    onMounted(() => {
      queryClassificationList();
      isHide.value = false;
    });
    const headerTop = computed(() => store.downloadBarVisible ? store.downloadBarHeight + 'px' : '0');
    const commonHeaderHeight = computed(() => {
      const base = route.path === '/home' && showFixNav.value ? 87 : 62;
      return base + (store.downloadBarVisible ? store.downloadBarHeight : 0) + 'px';
    });
    return (_ctx, _cache) => {
      const _component_HeaderNav = _resolveComponent("HeaderNav");
      const _component_SearchInput = _resolveComponent("SearchInput");
      const _component_CategoryNav = _resolveComponent("CategoryNav");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([{
          isHide: isHide.value,
          'isHome': _ctx.$route.path === '/home' && showFixNav.value ? true : false
        }, "home-fixed"]),
        style: _normalizeStyle({
          top: headerTop.value
        })
      }, [_createVNode(_component_HeaderNav, {
        onQuery: queryList
      })], 6), _createElementVNode("div", {
        class: _normalizeClass(["common-header", {
          'isHome': _ctx.$route.path === '/home' && isHide.value ? true : false
        }]),
        style: _normalizeStyle({
          height: commonHeaderHeight.value
        })
      }, null, 6), _ctx.$route.path === '/search' ? (_openBlock(), _createBlock(_component_SearchInput, {
        key: 0
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_CategoryNav, {
        class: _normalizeClass({
          'isHome': _ctx.$route.path === '/home' && showFixNav.value ? true : false,
          'isDwonload': _ctx.$route.path === '/home' && showFixNav.value && _unref(store).downloadBarVisible ? true : false
        }),
        list: categoryList.value,
        onQuery: queryList,
        ref_key: "cateRed",
        ref: cateRed
      }, null, 8, ["class", "list"]), [[_vShow, __props.categoryNavShow]])], 64);
    };
  }
};